var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-content',{attrs:{"code":"404","desc":"抱歉，您访问的页面不存在","comp":_vm.Svg404}})
}
var staticRenderFns = []

export { render, staticRenderFns }